import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { realisticIsraelFilters } from "../../../../shared/utils/entitiesFiltersUtils";
import { getKey } from "../../../../shared/utils/tabsUtils";
import { getObjectByKey } from "../../../../shared/utils/utils";
import { usePermission } from "../../../../shared/hooks/usePermission";
import MyCourseItem from "../../../../shared/components/features/courseItem/myCourseItem/MyCourseItem";
import Widget from "../../../../shared/components/features/widget/Widget";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./RealisticIsraelCoursesWidget.module.css";
import AddItem from "../../../../shared/components/features/addItem/AddItem";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";

const RealisticIsraelCoursesWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { platforms } = useSelector(state => state.uiData);
    const realisticIsraelCourses = useSelector(state => selectEntitiesByFilters(state, realisticIsraelFilters));
    const hasPermission = usePermission();
    const moodle = hasPermission(getKey("moodle-highschool")) ? getObjectByKey("moodle-highschool", platforms) : getObjectByKey("moodle-elementary", platforms)

    return (
        <Widget
            color="#FDDB71"
            title={`${texts.realisticIsrael ?? ""} ${texts.myStudyGroup ?? ""}`}
            icon={iconsList.myLearning}
            className={classes.RealisticIsraelCoursesWidget}
        >
            <div className={classes.CoursesList}>
                <NavigateLink link={moodle?.link}>
                    <AddItem className={classes.AddItem} imgSrc={moodle.smallIcon} icon={iconsList.addCircle} text={texts.openMoodlSG} />
                </NavigateLink>
                {realisticIsraelCourses?.map((course, index) => (
                    <MyCourseItem
                        key={course.id || course.externalId || index}
                        course={course}
                    />
                ))}
            </div>
        </Widget>
    );
};

export default RealisticIsraelCoursesWidget; 